import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import OrderForm from "./OrderForm";

const OrderAdd = () => {
    return (
        <Fragment>
            <OrderForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default OrderAdd;